"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Lang_1 = require("../Lang");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var mountIsland_1 = require("../mountIsland");
// @ts-ignore
var jquery_1 = __importDefault(require("jquery"));
window.$ = jquery_1.default;
window.jQuery = jquery_1.default;
require("datatables.net");
require("datatables.net-dt/css/jquery.dataTables.min.css");
function SearchSeminars() {
    var _this = this;
    var _a = (0, react_1.useState)([]), seminars = _a[0], setSeminars = _a[1];
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        var search = new URLSearchParams(window.location.search);
        // Forward only the three search selects. Anything else on the page URL — notably the
        // stray _token a GET form used to emit — is not a search input and must not reach the
        // endpoint. Format values contain "|" and Spanish accents, so they have to travel as a
        // query string; axios encodes them here rather than in a path segment, where Cloudflare's
        // WAF treats percent-encoded punctuation as an attack signature.
        var params = {
            language: (_a = search.get("language")) !== null && _a !== void 0 ? _a : "All Languages",
            format: (_b = search.get("format")) !== null && _b !== void 0 ? _b : "All Formats | Todos los formatos",
            timezone: (_c = search.get("timezone")) !== null && _c !== void 0 ? _c : "All Timezones",
        };
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get("/app/seminars/seminar-search", { params: params })];
                    case 1:
                        response = _a.sent();
                        console.log(response.data); // Keep this line for debugging
                        if (response.data && response.data.seminars) {
                            setSeminars(response.data.seminars);
                        }
                        else {
                            console.log("Unexpected response format or missing seminars property");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    (0, react_1.useEffect)(function () {
        if (seminars.length > 0) {
            var table_1 = (0, jquery_1.default)("#example-all").DataTable();
            (0, jquery_1.default)("#example-all_filter").hide();
            return function () {
                table_1.destroy();
            };
        }
    }, [seminars]);
    return (react_1.default.createElement(Box_1.default, null,
        react_1.default.createElement("table", { id: "example-all", className: "table table-hover table-bordered" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        (0, Lang_1.__)("Language"),
                        react_1.default.createElement("br", null),
                        "Idioma"),
                    react_1.default.createElement("th", null,
                        (0, Lang_1.__)("Format"),
                        react_1.default.createElement("br", null),
                        "Formato"),
                    react_1.default.createElement("th", { style: { width: 250 } },
                        (0, Lang_1.__)("Seminar Title (click link for details)"),
                        react_1.default.createElement("br", null),
                        "T\u00EDtulo del seminario"),
                    react_1.default.createElement("th", { style: { width: 300 } },
                        (0, Lang_1.__)("Contact Info"),
                        react_1.default.createElement("br", null),
                        "Informaci\u00F3n de contacto"),
                    react_1.default.createElement("th", null,
                        (0, Lang_1.__)("Frequency"),
                        react_1.default.createElement("br", null),
                        "Frecuencia"),
                    react_1.default.createElement("th", { style: { width: 200 } },
                        (0, Lang_1.__)("Timezone"),
                        react_1.default.createElement("br", null),
                        "Zona horaria"),
                    react_1.default.createElement("th", null,
                        (0, Lang_1.__)("Country"),
                        react_1.default.createElement("br", null),
                        "Pa\u00EDs"))),
            react_1.default.createElement("tbody", null, seminars.map(function (seminar) { return (react_1.default.createElement("tr", { key: seminar.id },
                react_1.default.createElement("td", null, seminar.language),
                react_1.default.createElement("td", null, seminar.format),
                react_1.default.createElement("td", null,
                    react_1.default.createElement(Link_1.default, { href: "/app/seminar-info/" + seminar.id, color: "inherit", underline: "hover" }, seminar.title)),
                react_1.default.createElement("td", null, seminar.contact),
                react_1.default.createElement("td", null, seminar.frequency),
                react_1.default.createElement("td", null, seminar.timezone),
                react_1.default.createElement("td", null, seminar.country))); })))));
}
exports.default = SearchSeminars;
var seminarResultsEl = document.getElementById("seminar-results");
if (seminarResultsEl) {
    (0, mountIsland_1.mountIsland)(seminarResultsEl, react_1.default.createElement(SearchSeminars, null));
}
